import { Box, Text, useColorModeValue, Button, Stack } from "@chakra-ui/react";
import React from "react";
import { track } from "api/analytics";
import { NOTIFICATION_CLICKED } from "api/analytics/events";
import { useButtonProps } from "hooks";
import { ShowMoreContainer } from "screens/common/components/ShowMoreContainer";
import { MarkdownViewer } from "screens/markdown/MarkdownViewer";
import { ReactComponent as CharliLogoFull } from "screens/common/static/logos/charli-logo-full.svg";
import { useCopyValue } from "hooks/useCopies";

interface Props {
  onDismiss: () => void;
  newVersionDate: number;
}

export const VersionTile = (props: Props) => {
  const source = "toast";
  const notificationType = "new_webapp_version";
  const bgColorHeader = useColorModeValue("white", "gray.700");
  const colorHeader = useColorModeValue("#009AD8", "gray.200");
  const ctaButtonProps = useButtonProps("sm", "cta");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("primary.darkGray", "gray.400");
  const bgColor = useColorModeValue("white", "gray.700");
  const versionMessage = useCopyValue("copy_markdown_new_version_message");

  return (
    <Box
      className="notification-tile"
      borderRadius={"xl"}
      overflow="hidden"
      boxShadow={"2xl"}
      bgColor={bgColor}
      borderColor={borderColor}
      borderWidth={"2px"}
      borderTop={"original"}
      cursor={"unset"}>
      <Stack direction="row" justifyContent={"space-between"} alignItems="center" p={3} bgColor={bgColorHeader}>
        <CharliLogoFull
          className="update-logo"
          style={{
            width: `90px`,
            height: `17px`,
          }}
        />
        <Text fontSize={"sm"} color={colorHeader} fontWeight={"semibold"} backgroundColor={bgColorHeader}>
          {`New Version Available!`}
        </Text>
      </Stack>
      <Stack spacing="0" px={3} pb={3} bgColor={bgColor}>
        <Stack>
          <ShowMoreContainer height="8.5rem" minHeight="5rem">
            <MarkdownViewer backgroundColor={bgColor} fontColor={textColor} content={versionMessage} />
          </ShowMoreContainer>
        </Stack>
        <Stack direction="row" justifyContent={"flex-end"} width="100%">
          <Button
            aria-label="Accept"
            {...ctaButtonProps}
            onClick={() => {
              track(NOTIFICATION_CLICKED, { notification_type: notificationType, source });
              window.location.reload();
            }}>
            Get Latest Version
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
